<template>
  <div class="wrapper">
    <Menu />
    <div class="header-area">
      <div class="container-fluid">
        <div class="position-relative row player-career user-profile">
          <div class="mt-5 user-profile-head">
            <div class="profil-edit float-right mr-3">
              <a
                href="javascript:;"
                @click="$openShare('https://www.anadoluefessk.org/fan-club/uye/' + user.id + '/' + user.slug, 'Anadolu Efes Fan Club Profilime Gözatın')"
              >
                <img src="/static/img/popup-share.svg" alt />
              </a>
            </div>
            <div class="user-image">
              <img
                :src="user.avatarUrl"
                alt
                class="rounded-circle mb-3 b-4"
                style="width: 100px; height: 100px"
              />
            </div>
            <h1 class="fs-20 fc-5 mb-3">
              {{user.first_name}}
              <span class="font-weight-normal">{{user.last_name}}</span>
            </h1>
            <h2
              class="fs-24 fc-1 mb-4"
              style="font-size: 17px"
            >{{user.checkin_count}} Maça Katıldın, {{user.total_point}} Puan Kazandın</h2>
          </div>
        </div>
      </div>
    </div>

    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <div class="tab-box">
              <div class="tab-header text-center bb-1">
                <div class="row no-gutters">
                  <div
                    class="col-4 tab-select"
                    :class="tab == 'account' ? 'active' : ''"
                    @click="changeTab('account')"
                  >
                    <h1 class="fs-16" :class="tab == 'account' ? 'fc-2' : 'fc-1'">Profilim</h1>
                  </div>
                  <div
                    class="col-4 tab-select"
                    :class="tab == 'follower' ? 'active' : ''"
                    @click="changeTab('follower')"
                  >
                    <h1 class="fs-16" :class="tab == 'follower' ? 'fc-2' : 'fc-1'">Takipçi</h1>
                  </div>
                  <div
                    class="col-4 tab-select"
                    :class="tab == 'following' ? 'active' : ''"
                    @click="changeTab('following')"
                  >
                    <h1 class="fs-16" :class="tab == 'following' ? 'fc-2' : 'fc-1'">Takip</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="tab == 'account'">
            <div class="fan-no py-3">
              <span class="fs-18 fc-3">
                Fan Club No:
                <span class="fc-1">{{user.fancard}}</span>
              </span>
            </div>

            <PointActions />

            <div class="col-12 p-0" v-if="tab == 'account'">
              <div class="item-box">
                <div class="box-header p-0">
                  <div class="tab-box">
                    <div class="tab-header text-center bb-1">
                      <div class="row no-gutters">
                        <div
                          class="col-6 tab-select"
                          :class="tab2 == 'accountActivities' ? 'active' : ''"
                          @click="changeTab2('accountActivities')"
                        >
                          <h1 class="fs-16">Hareketlerim</h1>
                        </div>
                        <div
                          class="col-6 tab-select"
                          :class="tab2 == 'followActivities' ? 'active' : ''"
                          @click="changeTab2('followActivities')"
                        >
                          <h1 class="fs-16">Takip Hareketleri</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="box-body" v-if="tab2 == 'followActivities'">
                  <UserActions />
                </div>

                <div class="box-body" v-if="tab2 == 'accountActivities'">
                  <MyActions />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 p-0" v-if="tab == 'follower'">
            <div class="item-box">
              <div class="box-body">
                <div class="profil-list">
                  <div
                    class="profil-list-item row py-2 bb-1"
                    v-for="(item, index) in followers"
                    :key="index"
                  >
                    <div class="col-9">
                      <a href="javascript:;" @click="getProfile(item)">
                        <div class="profil-detail">
                          <div class="user-image">
                            <img
                              style="width: 52px; height: 52px"
                              :src="item.avatarUrl"
                              class="w-100 rounded-circle"
                            />
                          </div>
                          <h1 class="fs-21 fc-1 py-3 mx-2 float-left">{{item.full_name}}</h1>
                        </div>
                      </a>
                    </div>
                    <div class="col-3 p-0">
                      <button
                        :class="item.is_following ? 'unfollow p-1 py-2' : 'follow p-1 py-2'"
                        @click="toggleFollow(item, 'follower')"
                      >{{ item.is_following ? 'Takipten Cikar' : 'Takip Et' }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 p-0" v-if="tab == 'following'">
            <div class="item-box">
              <div class="box-body">
                <div class="profil-list">
                  <div
                    class="profil-list-item row py-2 bb-1"
                    v-for="(item, index) in followings"
                    :key="index"
                  >
                    <div class="col-9">
                      <a href="javascript:;" @click="getProfile(item.id)">
                        <div class="profil-detail">
                          <div class="user-image">
                            <img
                              style="width: 52px; height: 52px"
                              :src="item.avatarUrl"
                              class="w-100 rounded-circle"
                            />
                          </div>
                          <h1 class="fs-21 fc-1 py-3 mx-2 float-left">{{item.full_name}}</h1>
                        </div>
                      </a>
                    </div>
                    <div class="col-3 p-0">
                      <button
                        :class="item.is_following ? 'unfollow p-1 py-2' : 'follow p-1 py-2'"
                        @click="toggleFollow(item, 'follower')"
                      >{{ item.is_following ? 'Takipten Cikar' : 'Takip Et' }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import PointActions from "@/components/PointActions";
import MyActions from "@/components/MyActions";
import UserActions from "@/components/UserActions";
import axios from "axios";
export default {
  name: "Account",
  components: {
    Footer,
    Menu,
    Header,
    PointActions,
    MyActions,
    UserActions
  },
  data() {
    return {
      tab: "account",
      tab2: "accountActivities",
      followers: [],
      followings: []
    };
  },
  beforeMount() {
    axios
      .get("uyelik/hesap?token=" + this.$store.state.user.token)
      .then(res => {
        this.$store.state.user = res.data.data;
      });

    var data = new FormData();
    data.append("user_token", this.$store.state.user.token);

    axios.post("sosyal/takip-edenler", data).then(res => {
      this.followers = res.data.data;
    });

    axios.post("sosyal/takip-ettiklerim", data).then(res => {
      this.followings = res.data.data;
    });
  },
  methods: {
    changeTab(tabName) {
      this.tab = tabName;
    },
    changeTab2(tabName) {
      this.tab2 = tabName;
    },
    follow(item, tab) {
      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("following_user_id", item.id);
      axios.post("sosyal/takip-et", data).then(res => {
        if (res.data.status != 200) {
          this.$message.error(res.data.data);
          return;
        }
        if (tab == "following") {
          var index = this.followings.findIndex(k => k.id == item.id);
          this.followings[index].is_following = true;
        } else {
          var index = this.followers.findIndex(k => k.id == item.id);
          this.followers[index].is_following = true;
        }
      });
    },
    unfollow(item, tab) {
      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("following_user_id", item.id);
      axios.post("sosyal/takipten-cikar", data).then(res => {
        if (tab == "following") {
          var index = this.followings.findIndex(k => k.id == item.id);
          this.followings[index].is_following = false;
        } else {
          var index = this.followers.findIndex(k => k.id == item.id);
          this.followers[index].is_following = false;
        }
      });
    },
    toggleFollow(item, tab) {
      if (item.is_following) {
        this.unfollow(item, tab);
      } else {
        this.follow(item, tab);
      }
    },
    getProfile(id) {
      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("user_id", id);
      axios.post("sosyal/profil", data).then(res => {
        if (res.data.status == 401) {
          this.$message.error(res.data.data);
          return;
        }
        this.$router.push({
          name: "UserProfile",
          params: { data: res.data.data, id: res.data.data.id }
        });
      });
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Account.vue